// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-1cYnx";
var _5 = "main-3obna";
var _6 = "index-2Konc";
var _7 = "label-2Ys5p";
var _8 = "select-2f9EU";
var _9 = "payload-3ousM";
var _a = "seats-1fkf_";
var _b = "seatPrice-31Jzl";
var _c = "freeSeat-2kHlE";
var _d = "money-25qOm";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "mobile", _4 as "wrapper", _5 as "main", _6 as "index", _7 as "label", _8 as "select", _9 as "payload", _a as "seats", _b as "seatPrice", _c as "freeSeat", _d as "money" }
export default { "__esModule": _1, "tabletMiddle": _2, "mobile": _3, "wrapper": _4, "main": _5, "index": _6, "label": _7, "select": _8, "payload": _9, "seats": _a, "seatPrice": _b, "freeSeat": _c, "money": _d }
